import { ROUTE_API } from "constant";
import { IBaseDataForPaginate } from "interfaces";
import { IGetMediaForPaginateInputModel, IMediaOutputModel, IUpdateMediaInputModel } from "interfaces/media";
import apiV3 from "utils/api.v3";

export const MediaServices = {
  getMedia,
  createMedia,
  updateMedia,
  removeMedia,
};

function getMedia(data: IGetMediaForPaginateInputModel) {
  return apiV3.get<IBaseDataForPaginate<IMediaOutputModel>>({ url: ROUTE_API.MEDIA_ROUTE.GET_MEDIA, query: data });
}

function createMedia(data: FormData) {
  return apiV3.post(
    { url: ROUTE_API.MEDIA_ROUTE.CREATE_MEDIA, data },
    { "Content-Type": "multipart/form-data; charset=utf-8" }
  );
}

function updateMedia(mediaId: string, data: IUpdateMediaInputModel) {
  return apiV3.put({ url: ROUTE_API.MEDIA_ROUTE.UPDATE_MEDIA.replace("{MEDIA_ID}", mediaId), data });
}

function removeMedia(mediaId: string) {
  return apiV3.delete({ url: ROUTE_API.MEDIA_ROUTE.REMOVE_MEDIA.replace("{MEDIA_ID}", mediaId) });
}
